<div style="height: 300px;width: 100%;" #mapContainer></div>
